<template>
  <section class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 relative overflow-hidden bg-[#0b105d]">
    <div
      class="absolute inset-0 bg-gradient-to-b from-transparent via-[#fe6d0d]/5 to-transparent"
    ></div>
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 relative z-10">
      <div class="max-w-3xl sm:max-w-4xl lg:max-w-5xl mx-auto" data-aos="fade-up">
        <div class="relative">
          <div
            class="absolute inset-0 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] rounded-2xl sm:rounded-3xl blur-2xl opacity-20"
          ></div>
          <div
            class="relative bg-gradient-to-br from-[#ffb47c] to-[#fe6d0d] rounded-2xl sm:rounded-3xl p-8 sm:p-10 md:p-12 lg:p-16 shadow-2xl"
          >
            <h2
              class="text-2xl sm:text-3xl md:text-4xl font-bold text-[#ffffff] mb-6 sm:mb-8 text-center"
            >
              {{ $t('aboutUsPage.mainGoal').split(':')[0] }}
            </h2>
            <p class="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed text-center">
              {{
                $t('aboutUsPage.mainGoal').includes(':')
                  ? $t('aboutUsPage.mainGoal')
                      .substring($t('aboutUsPage.mainGoal').indexOf(':') + 1)
                      .trim()
                  : $t('aboutUsPage.mainGoal')
              }}
            </p>
            <div class="mt-6 sm:mt-8 flex justify-center">
              <div
                class="w-16 sm:w-20 md:w-24 h-1 bg-gradient-to-r from-[#0b105d] to-[#b2b7f8] rounded-4xl"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts"></script>
